import React from 'react'
import './radio-options.css'

const RadioOptions = props => {
    const radio = props.list

    return (
        <div className='container-radio-option'>
            {radio.map((d, i) => {
                return (
                    <div key={i} style={{display: 'flex'}}>
                    <input type="radio" name="radio-option" id={`${i}-${d.value}`} className="radio-option" disabled={props.disabled} onChange={() => props._function(d)} defaultChecked={d.checked}/>
                    <label className="label-radio-option" htmlFor={`${i}-${d.value}`}>{d.label}</label>
                </div>
                )

            })}

        </div>
    )
}

export default RadioOptions